'use client';

import { Link } from '@/i18n/navigation';
import { Text } from '@chakra-ui/react';

const Logo = () => {
  return (
    <Link href="/">
      <Text fontSize="xl" fontWeight="bold" color="orange.400">
        FOODLY
      </Text>
    </Link>
  );
};

export default Logo;
